query GetAttachmentsInfo($recordId: ID!, $recordType: String!) {
  attachments(recordId: $recordId, recordType: $recordType) {
    id
    parentId
    fileName
    fileSizeHumanReadable
    contentType
    systemModstamp
  }
}
